var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_188_50488",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_188_50488)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.55211 17.5754C9.41877 17.5754 9.29377 17.5546 9.17711 17.5129C9.06044 17.4712 8.95211 17.4004 8.85211 17.3004L4.55211 13.0004C4.36877 12.8171 4.28127 12.5796 4.28961 12.2879C4.29794 11.9962 4.39377 11.7587 4.57711 11.5754C4.76044 11.3921 4.99377 11.3004 5.27711 11.3004C5.56044 11.3004 5.79377 11.3921 5.97711 11.5754L9.55211 15.1504L18.0271 6.67539C18.2104 6.49206 18.4479 6.40039 18.7396 6.40039C19.0313 6.40039 19.2688 6.49206 19.4521 6.67539C19.6354 6.85872 19.7271 7.09622 19.7271 7.38789C19.7271 7.67956 19.6354 7.91706 19.4521 8.10039L10.2521 17.3004C10.1521 17.4004 10.0438 17.4712 9.92711 17.5129C9.81044 17.5546 9.68544 17.5754 9.55211 17.5754Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.b34c01620b1563eb72e9efd38401cab0.svg";
export { ForwardRef as ReactComponent };